import popuptemplate from '../views/rename-club.html';
import deleteClubTemplate from '../views/delete-club.html';
import addPostTemplate from '../views/add-post.html';
import editClubLogeTemplate from '../views/edit-logo.html';
import templateForSelectedPost from '../views/show-selected-post.html';
import templateForSingleComment from '../views/single-comment.html';
import templateLike from '../views/like.html';
import commentTemplate from '../views/comment.html';
class ClubPost {
    constructor($scope, $state, $stateParams, $mdMedia, $mdDialog, $rootScope,
        authService, localStorageService, CONSTANTS) {
        'ngInject';

        $rootScope.title = "Club"

        $scope.getClubActivity = [];
        $scope.comment = [];

        //To check privilege
        //$scope.canCreateClub = false;
        $scope.accessSettings = false;
        $scope.updateClub = false;
        $scope.addMembers = false;
        $scope.toRemoveUser = false;
        $scope.isDeleteClub = false;
        $scope.canComment = false;
        $scope.setPrivacy = false;
        $scope.deletePost = false;
        $scope.loadPrimary = true;
        $scope.loadPrivileges = false;
        let isCreator = false;
        $scope.isLoaded = false;
        $scope.isLoading = true;

        //To get club details
        $scope.getClubs = [];
        $scope.clubActivity = [];

        let members = [];
        var uid = localStorageService.get('user_id'); //login user id
        $scope.userIdOf = uid;
        $scope.urlval = CONSTANTS.FILE_UPLOAD_URL;


        // this.subscribe('clubActivity');
        var localSchoolId = localStorageService.get('school_id')
        function loadInitial() {
            let send = {
                school_id: localStorageService.get('school_id')
            }
            authService.callAPI("/v0/club/me", "POST",
                { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                    try {
                        if (!resp.error) {
                            autoRun(resp.result.data.details)
                        }
                        console.log(resp)

                    } catch (e) {

                    }

                })
        }
        this.$onInit = () => {
            loadInitial()
        }
        // this.subscribe('clubList', () => [localStorageService.get('school_id')]);
        // this.subscribe('getModulesFeatures', () => [localStorageService.get('school_id')]);
        if (localStorageService.get('selectedClubId')) {
            $scope.selectedClubId = localStorageService.get('selectedClubId')
            localStorageService.set('selectedClubId', $scope.selectedClubId);
        } else {
            $scope.selectedClubId = '';
        }



        //********************loadmore STARTS*************************
        //Obtain current club details after each activity
        $scope.counter = 0;
        $scope.loadMore = function (club_id) {

            if (localStorageService.get('isClubOwnerID')) {
                $scope.isClubOwnerID = localStorageService.get('isClubOwnerID');
            }

            $scope.activeClub = club_id
            let i = 1;
            let activityCount = _.filter($scope.clubActivityResponse, function (cA) {
                return cA.club_id == club_id && cA.status == "active"
            })
            let totalActvityCount = activityCount.length
            $scope.counter = (totalActvityCount <= $scope.counter) ? totalActvityCount : $scope.counter + 2;


            let roleHead = $scope.userDoc;
            let getRoleIdd;
            if (roleHead) {
                getRoleIdd = roleHead.role_id;

                if (localStorageService.get('loadFirstTime') != '') {

                    // to show only selected club activity
                    $scope.getClubActivity = [];
                    let getClubActivity = _.filter($scope.clubActivityResponse, function (cA) {
                        return cA.club_id == club_id && cA.status == "active"
                    })
                    _.each(getClubActivity, function (eachActivity) {
                        let addedPost = false;
                        if (eachActivity && eachActivity.view === "public") {
                            $scope.getClubActivity.push(eachActivity);
                            addedPost = true;
                        } else if (eachActivity && eachActivity.added_by === uid && eachActivity.view != "public") {
                            $scope.getClubActivity.push(eachActivity);
                            addedPost = true;
                        } else if (eachActivity && eachActivity.added_by != uid && eachActivity.view != "public" && eachActivity.owner_id === uid) {
                            $scope.getClubActivity.push(eachActivity);
                            addedPost = true;
                        }
                        if ($scope.isDeleteClub && !addedPost) {
                            $scope.getClubActivity.push(eachActivity);
                        }
                    })
                } else { // to show all club activities(posts)
                    $scope.getClubActivity = [];
                    let getClubActivity = _.filter($scope.clubActivityResponse, function (cA) {
                        return cA.club_id.indexOf($scope.myActiveClubID) !== -1
                    })

                    _.each(getClubActivity, function (allPosts) {
                        let addedPost = false;
                        if (allPosts.view === "public") {
                            $scope.getClubActivity.push(allPosts);
                            addedPost = true;
                        } else if (allPosts && allPosts.added_by === uid && allPosts.view != "public") {
                            $scope.getClubActivity.push(allPosts);
                            addedPost = true;
                        } else if (allPosts && allPosts.added_by != uid && allPosts.view != "public" && allPosts.owner_id === uid) {
                            $scope.getClubActivity.push(allPosts);
                            addedPost = true;
                        }
                        if ($scope.isDeleteClub && !addedPost) {
                            $scope.getClubActivity.push(allPosts);
                        }
                        // allPosts.clubName = Club.findOne({
                        //   _id: allPosts.club_id
                        // }).name
                    })
                    $scope.activeClub = '';
                }
                $scope.getPostDetailsByCID()
            }
        }


        //******************loadmore ENDS**************************** 

        /*
         * To get details of posts in each club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.getPostDetailsByCID = (data) => {
            console.log(data)
            if (data) { //after delete the club
                localStorageService.set('selectedClubId', '')
                $scope.selectedClubId = ''
                $scope.getClubActivity = ''
            } else {
                let userMem, memName;
                userMem = $scope.userDoc
                //$scope.clubActivity = angular.copy($scope.getClubActivity);
                $scope.clubActivity = $scope.getClubActivity;

                _.each($scope.clubActivity, function (eachPost) {
                    userMem = _.find($scope.allUserDocs, function (one) {
                        return one._id == eachPost.added_by
                    })
                    // userMem = result;
                    if (userMem != undefined) {
                        eachPost.postedBy = userMem.name
                    }
                    if (eachPost.likes) { //to get the likes count for each posts
                        eachPost.likesCount = eachPost.likes.length
                        eachPost.likeMem = _.contains(eachPost.likes, uid);
                    } else {
                        eachPost.likesCount = 0
                    }
                    if (eachPost.comments) { //to get the comments count for each posts
                        eachPost.commentsCount = eachPost.comments.length;
                    } else {
                        eachPost.commentsCount = 0
                    }
                    if (eachPost.owner_id == uid) {
                        eachPost.isClubOwner = true
                    } else {
                        eachPost.isClubOwner = false
                    }
                    if (eachPost.added_by == uid) {
                        eachPost.isShow = true
                    } else {
                        eachPost.isShow = false
                    }

                    if (eachPost.view == 'public') {
                        eachPost.postView = true
                    } else {
                        eachPost.postView = false
                    }

                    if (eachPost.type === 'image') {

                        let str = eachPost.url.split('http')
                        if (str.length && str.length < 2) {
                            eachPost.url = CONSTANTS.FILE_UPLOAD_URL + eachPost.url;
                        }
                    } else {
                        if (eachPost.type === 'video') {
                            if (eachPost.url) {
                                let str = eachPost.url.split('http')
                                if (str.length && str.length < 2) {
                                    eachPost.thumbUrl = CONSTANTS.FILE_UPLOAD_URL + eachPost.url.thumbnail_url;
                                    eachPost.url = CONSTANTS.FILE_UPLOAD_URL + eachPost.url.video_url;
                                }
                            }
                        }
                    }

                    if (eachPost.added_by == uid || ($scope.userAccess && $scope.userAccess.deleteClub && $scope.userAccess.deleteClub.create)) {
                        $scope.deletePost = true;

                    }

                    if (eachPost.owner_id == uid) {
                        eachPost.setPrivacy = true;
                    }

                    _.each(eachPost.comments, function (user) { //to get user name based on user id
                        let result = _.find($scope.allUserDocs, function (one) {
                            return one._id == user.user_id
                        })
                        user.userName = result.name;
                        if (result.image && result.image.original)
                            user.profileImg = CONSTANTS.FILE_UPLOAD_URL + result.image.original
                        else
                            // /home/cordova/node_project/educore_3.5/server/file-server/public/uploads/profile_145-03.png
                            user.profileImg = CONSTANTS.FILE_UPLOAD_URL + "/uploads/profile_145-03.png";

                    })
                })
            }
        }

        /*
         * To get club details after club activities
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.getClubDetails = (club_id, ownerId) => {
            $scope.toRemoveUser = false;
            $scope.addMembers = false;
            $scope.loadPrimary = true;
            $scope.loadPrivileges = true;
            // to get the selected club id (from dropbox) and related posts
            localStorageService.set('loadFirstTime', true);
            $scope.loadFirstTime = localStorageService.get('loadFirstTime');
            var v = true;
            localStorageService.set('selectedClubId', club_id);
            localStorageService.set('isClubOwnerID', ownerId);
            $scope.selectedClubId = localStorageService.get('selectedClubId');
            if ($scope.selectedClubId) {
                $scope.isClubId = true;
                $scope.isClubOwnerID = ownerId;
            }
            if ($scope.allpost) {
                $scope.allpost = false;
            }
            if (ownerId == localStorageService.get('user_id')) {
                $scope.toRemoveUser = true;
                $scope.addMembers = true;
            }
            $scope.loadMore(localStorageService.get('selectedClubId'));
            //$scope.$apply();

        }

        /*
         * To get details of selected clud 
         * 
         * @param : null
         * 
         * @return - null
         */
        $scope.loadMoreData = function () {
            $scope.loadMore($scope.selectedClubId);
        }


        $scope.loadCheckData = () => {
            $scope.loadMore($scope.selectedClubId);
        }


        function autoRun(firstReponse) {

            try {
                $scope.userDoc = firstReponse.getUserDetails
                $scope.allUserDocs = firstReponse.allUserDocs
                let clubs = firstReponse.resClubs, clubActivity = firstReponse.resClubActivity
                $scope.clubs = firstReponse.resClubs, $scope.clubActivityResponse = firstReponse.resClubActivity
                $scope.myActiveClubID = []
                if (localStorageService.get('selectedClubId')) {
                    $scope.loadMoreData();
                    $scope.loadMore($scope.selectedClubId, $scope.isClubOwnerID)
                }
                /*************** START USER PRIVILEGES *************/
                let UserPrivilages = localStorageService.get('module_privileges')
                let moduleEx = _.find(UserPrivilages, function (one) {
                    return one.name == "Club"
                })
                if (moduleEx) {
                    let feat = localStorageService.get('feature_privileges')
                    let clubUserAccess = _.filter(feat, function (one) {
                        return one.module_state == "clubPost"
                    })

                    if (clubUserAccess && clubUserAccess.length > 0) {

                        $scope.userAccess = {};
                        _.each(clubUserAccess, function (clubObj) {
                            let user_access = {};
                            _.each(clubObj.privilege, function (privObj) {
                                user_access[privObj.name.toLowerCase()] = privObj.status
                            })
                            $scope.userAccess[clubObj.feature_id] = user_access;
                        })

                        if ($scope.userAccess) {
                            if ($scope.userAccess.createClub && $scope.userAccess.createClub.create) {
                                $scope.canCreateClub = true;
                                $scope.accessSettings = true;
                                //$scope.$apply();
                            }

                            // if ($scope.userAccess.addMembers && $scope.userAccess.addMembers.edit) {

                            // }
                            if ($scope.userAccess.addPost && $scope.userAccess.addPost.create) {
                                $scope.isCreatePost = true;
                            }
                            if ($scope.userAccess.likeAndComment && $scope.userAccess.likeAndComment.edit) {
                                $scope.canComment = true;
                            }
                            if ($scope.userAccess.likeAndComment && $scope.userAccess.likeAndComment.read) {
                                $scope.readComment = true;
                            }


                            if ($scope.userAccess.deleteClub && $scope.userAccess.deleteClub.create) {
                                $scope.isDeleteClub = true;
                            }

                        }

                    } else {
                        $state.go("dashboard")
                    }

                    let moduleDetails = firstReponse.moduleDetails
                    let roleIds = firstReponse.getUserDetails
                    if (roleIds) {
                        roleIds = roleIds.role_ids;
                        $scope.assignNames = '';
                        _.each(roleIds, function (roleId) {
                            if (moduleDetails && moduleDetails.feature_role) {
                                _.each(moduleDetails.feature_role, function (eachRole) {
                                    if (eachRole.role_id == roleId) {
                                        if (eachRole.f_id == "hosComponent")
                                            $scope.assignNames += "HOS"
                                        else if (eachRole.f_id == "hodComponent")
                                            $scope.assignNames += "HOD"
                                        else if (eachRole.f_id == "parentComponent")
                                            $scope.assignNames += "Parent"
                                        else if (eachRole.f_id == "teacherComponent")
                                            $scope.assignNames += "Teacher"
                                        else if (eachRole.f_id == "studentComponent")
                                            $scope.assignNames += "Student"
                                        else if (eachRole.f_id == "principalComponent")
                                            $scope.assignNames += "Principal"
                                        else if (eachRole.f_id == "adminComponent")
                                            $scope.assignNames += "Super Admin"
                                    }
                                })
                            }
                        })
                        if (moduleDetails && $scope.assignNames.indexOf("Super Admin") != -1) {
                            if (localStorageService.get('selectedClubId')) {
                                console.log(1)

                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year')
                                })
                                console.log($scope.getClubs)
                                $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'))
                            } else {
                                console.log(11)
                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year')
                                })
                                if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                    $scope.activeClub = $scope.getClubs[0]._id
                                    $scope.selectedClubId = $scope.getClubs[0]._id
                                    if ($scope.selectedClubId) {
                                        $scope.isClubId = true
                                        $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                        localStorageService.set('isClubOwnerID', $scope.isClubOwnerID)
                                    }
                                    if ($scope.loadPrimary)
                                        $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                }
                            }
                            _.each($scope.getClubs, function (doc) {
                                $scope.myActiveClubID.push(doc._id);
                            })
                            $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                            $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                        }
                        if (moduleDetails && $scope.assignNames.indexOf("Student") != -1) { //only for students
                            console.log(111)
                            if (localStorageService.get('selectedClubId')) {
                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year') &&
                                        _.find(one.users, function (fn) {
                                            return fn.user_id == uid
                                        })
                                })
                                $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'))
                            } else {
                                console.log(1111)
                                //return false;
                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year')
                                })

                                if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                    $scope.activeClub = $scope.getClubs[0]._id
                                    $scope.selectedClubId = $scope.getClubs[0]._id
                                    if ($scope.selectedClubId) {
                                        $scope.isClubId = true
                                        $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                        localStorageService.set('isClubOwnerID', $scope.isClubOwnerID)
                                    }
                                    if ($scope.loadPrimary)
                                        $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                }
                            }
                            _.each($scope.getClubs, function (doc) {
                                $scope.myActiveClubID.push(doc._id);
                            })
                            $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                            //$scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                        }
                        if (moduleDetails && $scope.assignNames.indexOf("Student") == -1 && $scope.assignNames.indexOf("Super Admin") == -1) {
                            console.log(11111)
                            if (localStorageService.get('selectedClubId')) {
                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year') &&
                                        (_.find(one.users, function (fn) {
                                            return fn.user_id == uid
                                        }) || one.created_by == uid)
                                })
                                $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'))
                            } else {
                                console.log(111111)
                                $scope.getClubs = _.filter(clubs, function (one) {
                                    return one.status == "active" && one.school_id == localStorageService.get('school_id') &&
                                        one.academic_year == localStorageService.get('academic_year') &&
                                        (_.find(one.users, function (fn) {
                                            return fn.user_id == uid
                                        }) || one.created_by == uid)
                                })
                                let myActiveClubIDCount = $scope.myActiveClubID.length;
                                console.log(1111111)
                                if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                    $scope.activeClub = $scope.getClubs[0]._id;
                                    $scope.selectedClubId = $scope.getClubs[0]._id;
                                    $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                    localStorageService.set('isClubOwnerID', $scope.isClubOwnerID)
                                    if ($scope.selectedClubId) {
                                        $scope.isClubId = true;
                                    }
                                    if ($scope.assignNames.indexOf("Teacher") != -1 && $scope.getClubs[0].created_by == uid) {
                                        $scope.isShow = true;
                                    }
                                    if ($scope.loadPrimary)
                                        $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                } else {
                                    // if ($scope.createPost || $scope.createClub) {
                                    //   $scope.loadFirstTime = true;
                                    //   localStorageService.set('isClubOwnerID', '1001')
                                    // }
                                }
                            }

                            _.each($scope.getClubs, function (doc) {
                                $scope.myActiveClubID.push(doc._id);
                            })
                            $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                        }
                        if (moduleDetails && $scope.assignNames.indexOf("Parent") != -1) {
                            let childData = []
                            let getClubs = [];
                            Meteor.call("getPersonDataClub", uid, function (error, result) {
                                if (error) {
                                    toastr.error("Something went wrong, Try after some times")
                                } else {
                                    _.each(result[0].child, function (eachChild) {
                                        childData.push(eachChild._id);
                                    })
                                    if (localStorageService.get('selectedClubId')) {
                                        getClubs = Club.find({
                                            status: "active",
                                            academic_year: localStorageService.get('academic_year'),
                                            school_id: localStorageService.get('school_id'),
                                            "users.user_id": {
                                                $in: childData
                                            }
                                        }).fetch(); //to get child's club
                                        $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'))
                                    } else {
                                        getClubs = Club.find({
                                            status: "active",
                                            academic_year: localStorageService.get('academic_year'),
                                            school_id: localStorageService.get('school_id'),
                                            "users.user_id": {
                                                $in: childData
                                            }
                                        }, {
                                                sort: {
                                                    created_date: -1
                                                }
                                            }).fetch()
                                        if (getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                            $scope.activeClub = getClubs[0]._id;
                                            $scope.selectedClubId = getClubs[0]._id;
                                            $scope.isClubOwnerID = getClubs[0].created_by;
                                            localStorageService.set('isClubOwnerID', $scope.isClubOwnerID)
                                            if ($scope.selectedClubId) {
                                                $scope.isClubId = true
                                            }
                                            if ($scope.loadPrimary)
                                                $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                        }
                                    }
                                    if ($scope.getClubs == null && getClubs != null)
                                        $scope.getClubs = getClubs
                                    else if (getClubs != null && $scope.getClubs != null) {
                                        _.each(getClubs, function (eachClub) {
                                            $scope.getClubs.push(eachClub);
                                        })
                                    }
                                    _.each($scope.getClubs, function (doc) {
                                        $scope.myActiveClubID.push(doc._id);
                                    })
                                    $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                                    //$scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                }
                            })



                        }
                        _.find($scope.getClubs, function (eachClub) {
                            if (eachClub.created_by === uid) {
                                isCreator = true;
                            }
                        })

                        if (isCreator) {
                            $scope.updateClub = true;
                            //$scope.$apply();
                        }
                    }
                    $scope.isLoading = false;
                    $scope.isLoaded = true;
                    // $scope.$apply();
                }
            } catch (e) {
                console.log(e)
            }
            /**************** END USER PRIVILEGES ***************/


            // Start :To set features during loading club activities
            //$scope.loading = true;

            if ($scope.loadFirstTime != true) {
                var v = false;
            } else {
                var v = $scope.loadFirstTime;
            }
            // End :To set features during loading club activities



            if ($stateParams.clubId) {
                $scope.selectedClubId = $stateParams.clubId;
                $scope.getClubDetails($stateParams.clubId, $stateParams.ownerId);
            }
            if ($stateParams.ownerId)
                $scope.owner = $stateParams.ownerId



        }
        //To get Role of members and get club which user is part of.






        /*
         * To get complete activity list when button to view all post is selected 
         * 
         * @param : null
         * 
         * @return - null
         */
        $scope.getAllPosts = () => {
            localStorageService.set('loadFirstTime', '');
            localStorageService.set('selectedClubId', '');
            $scope.loadPrimary = false;
            $scope.selectedClubId = '';
            $scope.loadFirstTime = '';
        }



        $scope.createClub = function () {
            $state.go('createClub', {})
        }



        /*
         * To rename club title -popup
         * 
         * @param : null
         * 
         * @return - null
         */


        $scope.renameClub = () => {
            let currentClub = $scope.selectedClubId //selected club id
            $mdDialog.show({
                controller: RenameClubController,
                locals: {
                    "data": currentClub,
                    "parentCtrl": $scope,
                    clubActivity: $scope.clubActivityResponse,
                    clubs: $scope.clubs,
                    userDocs: $scope.allUserDocs,
                    CONSTANTS: CONSTANTS
                },
                template: popuptemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * To add more members to a club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.addUser = () => {
            $state.go('createClub', {
                "club_id": $scope.selectedClubId,
                "owner_id": localStorageService.get('isClubOwnerID'),
                "mode": "addmore"
            })
        }

        /*
         * To remove already existing members in club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.removeUser = () => {
            $state.go('createClub', {
                "club_id": $scope.selectedClubId,
                "owner_id": localStorageService.get('isClubOwnerID'),
                "mode": "remove"
            })
        }

        /*
         * To view all already existing members in club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.viewUser = () => {
            $state.go('createClub', {
                "club_id": $scope.selectedClubId,
                "owner_id": localStorageService.get('isClubOwnerID'),
                "mode": "view"
            })
        }

        /*
         * To delete an existing club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.deleteClub = () => {
            let currentClub = $scope.selectedClubId //selected club id
            $mdDialog.show({
                controller: DeleteClubController,
                locals: {
                    "data": currentClub,
                    "parentCtrl": $scope
                },
                template: deleteClubTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * To update club logo-popup
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.editLogo = () => {
            let currentClub = $scope.selectedClubId //selected club id
            $mdDialog.show({
                controller: EditLogoClubController,
                locals: {
                    "data": currentClub,
                    "parentScope": $scope,
                    clubActivity: $scope.clubActivityResponse,
                    clubs: $scope.clubs,
                    userDocs: $scope.allUserDocs,
                    CONSTANTS: CONSTANTS,
                    localStorageService: localStorageService
                },
                template: editClubLogeTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        $scope.viewClubUsers = () => {
            $state.go('createClub', {
                "club_id": $scope.selectedClubId,
                "owner_id": localStorageService.get('isClubOwnerID'),
                "mode": "view"
            })
        }

        /*
         * To add new post for members of club-popup
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.createPost = (id) => {


            let currentClub = $scope.selectedClubId //selected club id
            let ownerID = $scope.isClubOwnerID //selected club owner id
            $mdDialog.show({
                controller: CreatePostController,
                locals: {
                    "parentCtrl": $scope,
                    "data": currentClub,
                    "owner_id": ownerID,
                    clubActivity: $scope.clubActivityResponse,
                    clubs: $scope.clubs,
                    userDocs: $scope.allUserDocs,
                    CONSTANTS: CONSTANTS,
                    localStorageService: localStorageService
                },
                template: addPostTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * For viewing selected post -popup
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.showSelectedPost = (post_id, post_url, type) => {
            let currentClub = post_id //selected post id
            let postUrl = post_url //selected post url
            let post_type = type
            $mdDialog.show({
                controller: showSelectedPostController,
                locals: {
                    "data": currentClub,
                    "url": postUrl,
                    "type": post_type
                },
                template: templateForSelectedPost,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * For liking a post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.postLike = (post_id) => {
            // Meteor.call("postLike", post_id, Meteor.userId(), function (error, result) {
            //     if (error) {
            //         if (error.error) {
            //             toastr.error("Some thing went wrong !.Please try after some time.")
            //         }
            //     }
            // })
            let send = {
                school_id: localStorageService.get('school_id'),
                post: post_id,
                uid: localStorageService.get('user_id'),
                myUserId: localStorageService.get('user_id'),
            }
            authService.callAPI("/v0/club/postLike", "POST",
                { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                    try {
                        if (resp.error) {
                            toastr.error("Some thing went wrong !.Please try after some time.")
                        }
                        _.each($scope.clubActivity, function (oneCa) {

                            if (oneCa._id == post_id) {
                                oneCa.likeMem = true
                            } else {
                                oneCa.likeMem = false
                            }
                        })
                        $scope.$apply()
                    } catch (e) {
                        console.log(e)
                    }

                })
        }

        /*
         * To unlike an already liked post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.postUnLike = (post_id, post) => {
            let send = {
                school_id: localStorageService.get('school_id'),
                post: post_id,
                uid: localStorageService.get('user_id'),
                myUserId: localStorageService.get('user_id'),
            }
            authService.callAPI("/v0/club/postUnLike", "POST",
                { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                    try {
                        if (resp.error) {
                            toastr.error("Some thing went wrong !.Please try after some time.")
                        }
                        _.each($scope.clubActivity, function (oneCa) {

                            if (oneCa._id == post_id) {
                                oneCa.likeMem = false
                            } else {
                                oneCa.likeMem = true
                            }
                        })
                        $scope.$apply()
                    } catch (e) {
                        console.log(e)
                    }

                })
        }

        /*
         * To make post public and private by owner of post
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.postPrivillege = (post_id, privacy, post) => {
            let txt, successTxt;

            if (privacy === true) {

                txt = "Are you sure to make this post as private ?";
                successTxt = "Private mode is enabled !";
            } else {
                txt = "Are you sure to make this post as public ?";
                successTxt = "Public mode is enabled !";

            }
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent(txt)
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                // Meteor.call("toPublicView", post_id, privacy, function (error, result) {
                //     if (error) {

                //         toastr.error("Something went wrong !.Please try after some time.");

                //     } else {

                //         toastr.success(successTxt);
                //     }
                // })
                let send = {
                    schoolId: localStorageService.get('school_id'),
                    privacy: privacy,
                    postId: post_id,
                    myUserid: localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/club/toPublicView", "POST",
                    { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                        try {
                            if (resp.error) {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            } else {
                                toastr.success(successTxt);
                            }
                            $scope.$apply()
                        } catch (e) {
                            console.log(e)
                        }

                    })
            }, function () {
                post.postView = privacy
            });
        }

        /*
         * To add comments to post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.addCommentData = (post_id, index) => {
            let text = $scope.comment[index];
            if (text && text.length >= 1) {
                authService.callAPI("/v0/club/add/post/comment", "POST",
                    {
                        postId: post_id, comment: text, userId: localStorageService.get('user_id'),
                        uid: localStorageService.get('user_id')
                    }, function (resp) {
                        try {
                            if (!resp.error) {
                                toastr.success("Comment added successfully !")
                                $scope.comment[index] = '';
                                _.each($scope.clubActivityResponse, function (oneCa) {
                                    if (oneCa._id == post_id) {
                                        let thisComments = oneCa.comments
                                        _.each(thisComments, function (eachUser) {
                                            eachUser.comment = text
                                            eachUser.added_date = new Date()
                                        })
                                    }
                                })
                                $scope.$apply()
                            } else {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            }
                        } catch (e) {
                            console.log(e)
                        }

                    })
                // Meteor.call("addComments", post_id, text, Meteor.userId(), function (error, result) {
                //     if (error) {
                //         toastr.error("Some thing went wrong !.Please try after some time.")
                //     } else {

                //         toastr.success("Comment added successfully !")
                //         $scope.comment[index] = '';
                //     }
                // })
                //$scope.getClubDetails($scope.selectedClubId,$scope.isClubOwnerID)
            } else if (!text || text.length < 1) {
                toastr.error("Enter any comment")
            }
        }

        /*
         * To view a large comment completly of a post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.showSingleComment = (comment) => {
            let currentClub = $scope.selectedClubId //selected club id
            $mdDialog.show({
                controller: singleCommentController,
                locals: {
                    "data": comment
                },
                template: templateForSingleComment,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * To show who and all liked the post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.showLikedDetails = (post_id) => {




            $mdDialog.show({
                controller: LikeController,
                locals: {
                    "data": post_id,
                    clubActivity: $scope.clubActivityResponse,
                    clubs: $scope.clubs,
                    userDocs: $scope.allUserDocs,
                    CONSTANTS: CONSTANTS
                },
                template: templateLike,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen
            })
        }

        /*
         * To show complete lists of comments for a post by a member of club
         * 
         * @param : null
         * 
         * @return - null
         */

        //CommentController.$inject = ['$scope', '$mdDialog', 'data']
        $scope.showCommentDetails = function (ev, post_id) {


            var log_id = localStorageService.get('user_id')
            $scope.model = {};
            $mdDialog.show({
                controller: CommentController,
                template: commentTemplate,
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    "parentCtrl": $scope,
                    "data": post_id,
                    "logedUser": log_id,
                    clubActivity: $scope.clubActivityResponse,
                    clubs: $scope.clubs,
                    userDocs: $scope.allUserDocs,
                    CONSTANTS: CONSTANTS
                },
                clickOutsideToClose: false
            }).then(function (answer) {


                $scope.status = 'You said the information was "' + answer + '".';
            }, function () {
                $scope.status = 'You cancelled the dialog.';
            })
        }

        /*
         * To delete post by owner of post or club 
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.postDelete = (post_id) => {
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to remove this post ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                authService.callAPI("/v0/club/delete/post", "DELETE",
                    {postId:post_id}, function (resp) {
                        try{
                            if(resp.error){
                                toastr.error("Server Interpreted.Please try after some time.")
                            }else{
                                toastr.success("Post deleted successfully!")
                                $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                                $scope.$apply();
                            }
                        }catch(e){
                            console.log(e)
                        }
                })
            });
        }
        function RenameClubController($scope, $mdDialog, data, parentCtrl,
            clubActivity, clubs, userDocs, CONSTANTS) {
            $scope.clubId = data;
            $scope.postTitle = _.find(clubs, function (one) {
                return one._id == data && one.academic_year == localStorageService.get('academic_year')
            }).name
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.update = () => {
                if ($scope.postTitle == undefined) {
                    toastr.error("Club name can't be blank !")
                    return false
                }
                if ($scope.postTitle.length < 2) {
                    toastr.error("Club title is too short!");
                    return false;
                }
                if ($scope.postTitle.length > 100) {
                    toastr.error("Club title maximun length exceeds !");
                    return false;
                }
                var reg = /^([A-Za-z0-9])[^]*$/;
                let clubName = $scope.postTitle.match(reg) ? "passed" : "failed";
                if (clubName == 'failed') {
                    toastr.error("Please enter valid club title");
                    $scope.postTitle = '';
                    $("#club_title").focus();
                    return false;
                } else {
                    $scope.postTitle = $scope.postTitle;
                }
                let myUserId = localStorageService.get('user_id')
                let school_id = localStorageService.get('school_id')
                authService.callAPI("/v0/club/check-name/" + school_id + "/" + myUserId + "/" + $scope.postTitle, "GET",
                    {}, function (resp) {
                        try {
                            if (!resp.error) {
                                $scope.updateClub = {}
                                $scope.updateClub.club_id = $scope.clubId
                                $scope.updateClub.title = $scope.postTitle
                                $scope.updateClub.modified_by = myUserId
                                $scope.updateClub.modified_date = new Date()
                                $scope.updateClub.last_modified_by = myUserId
                                authService.callAPI("/v0/club/update/name", "POST",
                                    {
                                        clubId: $scope.clubId,
                                        clubDetails: $scope.updateClub
                                    }, function (response) {
                                        try {
                                            console.log(response)
                                            if (response.error) {
                                                toastr.error("Some thing went wrong !.Please try after some time.")
                                            } else {
                                                parentCtrl.getClubDetails($scope.clubId, myUserId);
                                                localStorageService.set('loadFirstTime', $scope.clubId);
                                                toastr.success("Club name updated successfully!")
                                                $mdDialog.cancel();
                                            }
                                        } catch (e) {
                                            console.log(e)
                                        }
                                    })
                            } else {
                                toastr.error("Club title exists, Please rename club title");
                                return false;
                            }
                        } catch (e) {
                            console.log(e)
                            toastr.error("Somethingwent wrong,Please try after sometimew")
                        }
                    })
            }
        }

        function DeleteClubController($scope, $mdDialog, parentCtrl, data) {
            $scope.clubId = data;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.clubDelete = () => {
                authService.callAPI("/v0/club/delete", "DELETE",
                    {
                        club_id: $scope.clubId, userId: localStorageService.get('user_id'),
                    }, function (resp) {
                        try {
                            if (!resp.error) {
                                toastr.success("Club deleted successfully!");
                                $mdDialog.cancel();
                                $scope.$apply()
                                parentCtrl.getPostDetailsByCID('delete')
                                localStorageService.set('selectedClubId', '')
                                $scope.getClubActivity = []
                                $scope.selectedClubId = ''
                                $scope.$apply()
                            } else {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            }
                        } catch (e) {
                            console.log(e)
                        }

                    })

            }
        }
        function EditLogoClubController($scope, $mdDialog, data, parentScope,
            clubActivity, clubs, userDocs, CONSTANTS, localStorageService, $timeout, $interval, uploadService) {

            $scope.clubId = data;
            $scope.loaderImg = false;
            $scope.browse_btn = true;
            $scope.edit_logo_btn = false;
            $scope.determinateValue = 1;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            let userId = localStorageService.get('user_id')
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            let logo = _.find(clubs, function (one) {
                return one._id == $scope.clubId
            }).logo
            $scope.postLogo = CONSTANTS.FILE_UPLOAD_URL + logo;
            $scope.myImage = '';
            $scope.editFileSelect = function (evt) {
                var file = evt[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };
            let editPostPopUp = function (pic, name) {
                //let baseUrl = $location.protocol() + "://" + $location.host()
                let serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
                let userPath = userId + "/clubActivity/"
                let fileObj = pic
                uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
                    if (result.url) {
                        $scope.actionEdit = false;
                        $scope.updateFileurl = result.url
                        $scope.updateLogoPopUp()
                    }
                    if (result.progress) {
                        $scope.updateFileurl = ""
                        $scope.progressRep = result.progress
                    }
                })

            }
            $scope.showPic = true
            $scope.showFooterBtns = function () {
                $scope.edit_logo_btn = true;
            }
            $scope.updateLOGO = function () {
                $scope.showPic = false
                $scope.browse_btn = false
                $scope.edit_logo_btn = false
                if ($scope.picFile) {
                    $scope.loaderImg = true;
                    editPostPopUp($scope.picFile);
                }
            };
            $scope.updateLogoPopUp = () => {
                let send = {
                    logo: $scope.updateFileurl,
                    cid: $scope.clubId,
                    myUserid: localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/club/create/updateLogo", "POST",
                    { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                        try {
                            if (resp.error) {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            } else {
                                $scope.loading = true;
                                $timeout(function () {
                                    $scope.picFile = undefined;
                                    $scope.loading = false;
                                    parentScope.getClubDetails($scope.clubId, userId);
                                    localStorageService.set('loadFirstTime', $scope.clubId);
                                    toastr.success("Logo updated successfully !")
                                    $mdDialog.cancel();
                                }, 200);
                            }
                            $scope.$apply()
                        } catch (e) {
                            console.log(e)
                        }

                    })

            }
        }
        function CreatePostController($scope, $mdDialog, parentCtrl, data, owner_id,
            clubActivity, clubs, userDocs, CONSTANTS, localStorageService,
            $timeout, $interval, uploadService) {
            $scope.currentDate = new Date();
            $scope.hidePopupButtons = true;
            $scope.clubId = data;
            $scope.owner_id = owner_id;
            $scope.determinateValue = 1;
            let myUserid = localStorageService.get('user_id')
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {


                $mdDialog.cancel();
            };
            if ($scope.picFile) {
                $scope.uploadedFileName = $scope.picFile.name;
            }
            $scope.myImage = '';
            $scope.showFileSelect = function (evt) {
                var x = 0;
                var file = evt[0];
                $scope.myImage = '';
                if (file.type == "video/webm") {
                    toastr.error("Unsupported format");
                    return false;
                }
                if (file.type) {
                    var uploadType = file.type;
                    if (uploadType == "video/mp4") {
                        x = 1;
                        $scope.myImage = '';
                        $scope.picFileVid = false;
                    } else {
                        var reader = new FileReader();
                        reader.onload = function (evt) {
                            $scope.$apply(function ($scope) {
                                x = 0;
                                $scope.picFileVid = true;
                                $scope.myImage = evt.target.result;
                            });
                        };
                        reader.readAsDataURL(file);
                    }
                }
            };
            let uploadPostPopUp = function (pic, name) {
                $interval(function () {
                    $scope.determinateValue += 1;
                    if ($scope.determinateValue > 100) {
                        $scope.determinateValue = 5;
                    }
                }, 300);
                //let baseUrl = $location.protocol() + "://" + $location.host()
                let serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
                //let serverUrl = "http://192.168.0.59:4000/server-uploads"
                let userPath = myUserid + "/clubActivity/"
                let fileObj = pic
                uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
                    if (result.url) {
                        $scope.actionEdit = false;
                        $scope.postFileurl = result.url;
                        if (fileObj && fileObj.type == 'video/mp4') {
                            $scope.postFileType = 'video';
                        } else {
                            $scope.postFileType = 'image';
                        }
                        $scope.addNewPost();
                    }
                    if (result.progress) {
                        $scope.updateFileurl = ""
                        $scope.progressRep = result.progress
                    }
                })
            }
            $scope.postComment = function () {
                $scope.errors = {};

                if ($scope.postTitle == undefined || $scope.postTitle == null) {
                    toastr.error("Add title");
                    return false;
                }

                if (!$scope.picFile && !$scope.postTitleArea) {
                    toastr.error("Please update with any post, text/image/video")
                    return false;
                }
                if ($scope.postTitleArea && $scope.postTitleArea.length > 1000) {
                    $scope.errors.message = "Description should be limited to 1000 letters"
                    return false;
                }

                if ($scope.postTitle && $scope.postTitle.length > 0 && $scope.postTitle.length < 2) {
                    toastr.error("Text is too short!");
                    return false;
                }

                $scope.uploading = true;
                if (!$scope.picFile && $scope.postTitle) {
                    //for text
                    $scope.hidePopupButtons = false;
                    $scope.loaderImg = true;
                    $scope.postFileType = 'text';
                    $scope.addNewPost();
                }

                if ($scope.picFile) {

                    if (!$scope.postTitle) {
                        $scope.postTitle = ""
                    }

                    $scope.hidePopupButtons = false;
                    $scope.loaderImg = true;
                    uploadPostPopUp($scope.picFile);
                }
            };
            $scope.postDataType = false;
            $scope.postType = () => {
                if ($scope.postDataType) {
                    return "public";
                } else {
                    return "private";
                }
            }

            $scope.addNewPost = () => {
                let clubOwner = _.find(clubs, function (one) {
                    return one._id == $scope.clubId &&
                        one.academic_year == localStorageService.get('academic_year')
                })
                $scope.clubPost = {};
                $scope.clubPost.club_id = $scope.clubId;
                $scope.clubPost.title = $scope.postTitle;
                $scope.clubPost.added_by = myUserid;
                $scope.clubPost.view = $scope.postType();
                $scope.clubPost.status = 'active';
                $scope.clubPost.url = $scope.postFileurl;
                $scope.clubPost.type = $scope.postFileType;
                $scope.clubPost.description = $scope.postTitleArea;
                $scope.clubPost.post_date = $scope.currentDate
                $scope.clubPost.owner_id = clubOwner.created_by;
                $scope.clubPost.school_id = localStorageService.get('school_id');
                if ($scope.postTitleArea) {
                    $scope.clubPost.textarea = $scope.postTitleArea;
                }

                let send = {
                    logo: $scope.updateFileurl,
                    cid: $scope.clubId,
                    myUserid: localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/club/add/post", "POST",
                    { post: $scope.clubPost, myUserId: localStorageService.get('user_id') }, function (resp) {
                        try {
                            if (resp.error) {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            } else {
                                $timeout(function () {
                                    $scope.picFile = undefined;
                                    toastr.success("Created successfully!")
                                    parentCtrl.getClubDetails($scope.clubId, clubOwner.created_by);
                                    localStorageService.set('loadFirstTime', $scope.clubId);
                                    $mdDialog.cancel();
                                }, 200);
                            }
                            $scope.$apply()
                        } catch (e) {
                            console.log(e)
                        }

                    })
                // Meteor.call("clubPost", $scope.clubPost, function (error, result) {
                //     $scope.uploading = false;
                //     if (error) {
                //         if (error.error) {
                //             toastr.error("Some thing went wrong !.Please try after some time.")
                //         }
                //     } else {



                //     }
                // });
            }
        }

        function showSelectedPostController($scope, $sce, $mdDialog, data, url, type, $compile) {
            $scope.post_Id = data;

            $scope.post_URL = $sce.trustAsResourceUrl(url);
            $scope.post_type = type;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }


        function singleCommentController($scope, $mdDialog, data) {
            $scope.comment = data;
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        function LikeController($scope, $mdDialog, data, clubActivity, clubs, userDocs, CONSTANTS) {
            $scope.likesIsLoading = true;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            let likedUserArray = _.find(clubActivity, function (o) {
                return o._id == data
            })
            $scope.likedUserDetail = [];
            _.each(likedUserArray.likes, function (userLiked) {
                let result = _.find(userDocs, function (one) {
                    return one._id == userLiked
                })
                let obj = {};
                if (result.image && result.image.original) {
                    obj = {
                        name: result.name,
                        image: FILE_UPLOAD_URL + result.image.original
                    }
                } else {
                    obj = {
                        name: result.name,
                        image: CONSTANTS.FILE_UPLOAD_URL + "/uploads/profile_145-03.png"
                    }
                }
                $scope.likedUserDetail.push(obj)
                $scope.likesIsLoading = false;

            })
        }
        function CommentController($scope, $mdDialog, parentCtrl, data, logedUser,
            clubActivity, clubs, userDocs, CONSTANTS) {
            $scope.commentsIsLoading = true;
            $scope.clubId = data;
            $scope.logedUser = logedUser;
            $scope.showCommentBox = false;
            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.commentsData = _.find(clubActivity, function (o) {
                return o._id == data
            }).comments
            $scope.userComments = []
            _.each($scope.commentsData, function (eachUser) {
                let result = _.find(userDocs, function (one) {
                    return one._id == eachUser.user_id
                })
                let userName = result.name
                let items = {
                    user_id: eachUser.user_id,
                    user_name: userName,
                    comment: eachUser.comment,
                    _id: eachUser._id,
                    logedUser: $scope.logedUser,
                    added_date: eachUser.added_date
                }
                $scope.userComments.push(items)
                $scope.commentsIsLoading = false;
            })
            $scope.deleteComment = (selectedCommt) => {
                $scope.commentId = selectedCommt._id;
                let send = {
                    cmtId: $scope.commentId,
                    cid: $scope.clubId,
                    userId: localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/club/delete/post/comment", "DELETE",
                    send, function (resp) {
                        try {
                            if (resp.error) {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            } else {
                                $mdDialog.cancel();
                                toastr.success("Successfully deleted your comment")
                            }
                            $scope.$apply()
                        } catch (e) {
                            console.log(e)
                        }

                    })
                // Meteor.call("deleteComment", $scope.clubId, $scope.commentId, function (error, result) {
                //     if (error) {

                //         toastr.error("Some thing went wrong !.Please try after some time.")
                //     } else {
                //         //parentCtrl.getClubDetails(Session.get('selectedClubId'))
                //         $mdDialog.cancel();
                //         toastr.success("Successfully deleted your comment")
                //     }
                // });
            }
            $scope.commentText = ''
            $scope.editComment = (selectedCommt) => {
                $scope.commentText = selectedCommt.comment
                $scope.showCommentBox = true;
                $scope.commentId = selectedCommt._id
                angular.element("#cmt").focus();
            }

            $scope.updateComment = () => {
                var cmt = $('textarea#cmt').val();
                // Meteor.call("updateComment", $scope.clubId, $scope.commentId, cmt, function (error, result) {
                //     if (error) {

                //         toastr.error("Some thing went wrong !.Please try after some time.")

                //     } else {
                //         toastr.success("Updated successfully !")
                //         //parentCtrl.getClubDetails(Session.get('selectedClubId'))
                //         $scope.showCommentBox = false;
                //         $mdDialog.cancel();
                //     }
                // });
                let send = {
                    club_id: $scope.clubId,
                    cmt_id: $scope.commentId,
                    cmt: cmt,
                    userId: localStorageService.get('user_id'),
                }
                authService.callAPI("/v0/club/update/post/comment", "PUT",
                    send, function (resp) {
                        try {
                            if (resp.error) {
                                toastr.error("Some thing went wrong !.Please try after some time.")
                            } else {
                                _.each(parentCtrl.clubActivityResponse, function (oneCa) {
                                    if (oneCa._id == $scope.clubId) {
                                        let thisComments = oneCa.comments
                                        _.each(thisComments, function (eachUser) {
                                            eachUser.comment = cmt
                                            eachUser.added_date = new Date()
                                        })
                                    }
                                })
                                toastr.success("Updated successfully !")
                                $scope.showCommentBox = false;
                                $mdDialog.cancel();
                            }
                            $scope.$apply()
                        } catch (e) {
                            console.log(e)
                        }

                    })
            }
        }

    }
}
export default ClubPost;



// WEBPACK FOOTER //
// ./src/app/club_activity/controllers/clubpostController.js